import { Samples } from '@/types';

export const SAMPLES = [
  { label: 'Золото', value: Samples.GOLD },
  { label: 'Платина', value: Samples.PLATINUM },
  { label: 'Серебро', value: Samples.SILVER },
  { label: 'Прочие', value: Samples.OTHER },
];
